import { FC } from 'react';
import ErrorBoundary from './common/component/error-boundary';
import GlobalContextProvider from './common/contexts';
import AppLayout from './layout';

const App: FC = () => {
  return (
    <ErrorBoundary>
      <GlobalContextProvider>
        <AppLayout />
      </GlobalContextProvider>
    </ErrorBoundary>
  );
};

export default App;
